"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductManagerFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var ProductManagerFactory = /** @class */ (function (_super) {
    __extends(ProductManagerFactory, _super);
    function ProductManagerFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    ProductManagerFactory.prototype.deploy = function (_name, _location, _address, _id, _maxRent, _security, _cancellationFee, _description, _status, overrides) {
        return _super.prototype.deploy.call(this, _name, _location, _address, _id, _maxRent, _security, _cancellationFee, _description, _status, overrides || {});
    };
    ProductManagerFactory.prototype.getDeployTransaction = function (_name, _location, _address, _id, _maxRent, _security, _cancellationFee, _description, _status, overrides) {
        return _super.prototype.getDeployTransaction.call(this, _name, _location, _address, _id, _maxRent, _security, _cancellationFee, _description, _status, overrides || {});
    };
    ProductManagerFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    ProductManagerFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    ProductManagerFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return ProductManagerFactory;
}(contracts_1.ContractFactory));
exports.ProductManagerFactory = ProductManagerFactory;
var _abi = [
    {
        inputs: [
            {
                internalType: 'string',
                name: '_name',
                type: 'string',
            },
            {
                internalType: 'string',
                name: '_location',
                type: 'string',
            },
            {
                internalType: 'address',
                name: '_address',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: '_id',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '_maxRent',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '_security',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '_cancellationFee',
                type: 'uint256',
            },
            {
                internalType: 'string',
                name: '_description',
                type: 'string',
            },
            {
                internalType: 'bool',
                name: '_status',
                type: 'bool',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'constructor',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: '_lessor',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: '_contractAddress',
                type: 'address',
            },
        ],
        name: 'EndRentalContract',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: '_lessor',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: '_lessee',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'address',
                name: '_contractAddress',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: '_start',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: '_end',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: '_rent',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: '_security',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: '_cancellationFee',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: '_incentive',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'string',
                name: '_item',
                type: 'string',
            },
        ],
        name: 'NewRentalContract',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: '_rentAddress',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: '_lessorAddress',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: '_lesseeAddress',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'string',
                name: '_item',
                type: 'string',
            },
        ],
        name: 'NewRenting',
        type: 'event',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_discount',
                type: 'uint256',
            },
        ],
        name: 'addDiscount',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        name: 'bookedDates',
        outputs: [
            {
                internalType: 'uint48',
                name: '',
                type: 'uint48',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'bookings',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'cancellationFee',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_incentive',
                type: 'uint256',
            },
            {
                internalType: 'uint48',
                name: 'start',
                type: 'uint48',
            },
            {
                internalType: 'uint48',
                name: 'end',
                type: 'uint48',
            },
        ],
        name: 'createAgreement',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'description',
        outputs: [
            {
                internalType: 'string',
                name: '',
                type: 'string',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        name: 'discounts',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_lessor',
                type: 'address',
            },
        ],
        name: 'emitEndEvent',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_lessorAddress',
                type: 'address',
            },
            {
                internalType: 'address',
                name: '_lesseeAddress',
                type: 'address',
            },
            {
                internalType: 'string',
                name: '_item',
                type: 'string',
            },
        ],
        name: 'emitNewRentingEvent',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'endAgreement',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        name: 'endingTime',
        outputs: [
            {
                internalType: 'uint48',
                name: '',
                type: 'uint48',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getBookedDates',
        outputs: [
            {
                internalType: 'uint48[2][]',
                name: '',
                type: 'uint48[2][]',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getDiscounts',
        outputs: [
            {
                internalType: 'uint256[]',
                name: '',
                type: 'uint256[]',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getNumberOfRents',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        name: 'isAuthorised',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        name: 'isRentValid',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'isRented',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'itemId',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'lessorAddress',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'lessorName',
        outputs: [
            {
                internalType: 'string',
                name: '',
                type: 'string',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'location',
        outputs: [
            {
                internalType: 'string',
                name: '',
                type: 'string',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'manager',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'maxRent',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        name: 'possibleRents',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_discount',
                type: 'uint256',
            },
        ],
        name: 'removeDiscount',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        name: 'rents',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'security',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        name: 'startingTime',
        outputs: [
            {
                internalType: 'uint48',
                name: '',
                type: 'uint48',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
];
var _bytecode = '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';
//# sourceMappingURL=ProductManagerFactory.js.map